// NOTICE: KAPTION-INTEGRATION
import { ref } from 'vue';

// Global state to manage which dropdown is currently open
const activeDropdown = ref(null);

export const useDropdownManager = () => {
  const openDropdown = id => {
    // Close any existing dropdown
    if (activeDropdown.value && activeDropdown.value !== id) {
      // Trigger close event for the previous dropdown
      const event = new CustomEvent('close-dropdown', {
        detail: { id: activeDropdown.value },
      });
      document.dispatchEvent(event);
    }

    // Set new active dropdown
    activeDropdown.value = id;
  };

  const closeDropdown = id => {
    if (activeDropdown.value === id) {
      activeDropdown.value = null;
    }
  };

  const isDropdownActive = id => {
    return activeDropdown.value === id;
  };

  return {
    openDropdown,
    closeDropdown,
    isDropdownActive,
    activeDropdown,
  };
};
